export default __webpack_public_path__ + "static/media/Futura-LT-Book.adcf2586.ttf";